/**
 * Global utility to convert from Cents to Dollars and cents
 *
 * @param value
 */
export let centsToDollars = function(value) {
  return Number((value / 100).toFixed( 2 ));
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/centsToDollars.utils.ts